import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button } from "../components/ui/button";

const OurStory = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
    });
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/images/DIK_4253.jpg)',
            filter: 'brightness(0.6)'
          }}
        />
        <div className="relative z-10 text-center text-white px-4" data-aos="fade-up">
          <h1 className="text-4xl md:text-7xl font-bold mb-6">Our Story</h1>
          <p className="text-xl md:text-2xl max-w-2xl mx-auto">
            Discover the story behind our passion for Indonesian coffee and the space we've created for the community.
          </p>
        </div>
      </section>

      <div className="container mx-auto px-6 md:px-8 py-12 md:py-24">

        {/* Our Story Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24 items-center">
          <div className="space-y-6" data-aos="fade-right">
            <h1 className="text-3xl md:text-5xl font-bold text-foreground">Our Story</h1>

            <div className="space-y-4 text-muted-foreground leading-relaxed text-lg">
              <p>
                Founded in 2018, Iraga Coffee & Roastery began its journey with a simple passion: to create coffee that tastes genuinely good and is made with care. As the brand grew and evolved, we took a new step forward in 2022 by continuing our journey under the name Iraga Coffee & Roastery.
              </p>
              <p>
                Our roastery was built with the intention of developing blends that reflect our identity–balanced, approachable, and consistent. Through wholesale and custom roasting, we aim to share Iraga's signature blends with cafes and spaces beyond our own, reaching more people while maintaining quality in every batch.
              </p>
              <p>
                At its core, Iraga is a warm and welcoming coffee place–where good coffee, thoughtful roasting, and honest hospitality come together.
              </p>
            </div>
          </div>

          <div className="relative h-[600px] w-full rounded-3xl overflow-hidden shadow-2xl" data-aos="fade-left">
            <img
              src="/images/2025-12-07.jpg"
              alt="Coffee Story"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

      </div>

      {/* Our Values Section */}
      <section className="py-20" style={{ backgroundColor: '#31415A' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {/* Images Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="h-80 md:h-[500px] rounded-2xl overflow-hidden shadow-lg" data-aos="fade-up">
                <img
                  src="/images/DIK_4253.jpg"
                  alt="Quality Coffee"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="h-80 md:h-[500px] rounded-2xl overflow-hidden shadow-lg" data-aos="fade-up" data-aos-delay="200">
                <img
                  src="/images/DIK_4004.jpg"
                  alt="Sustainability"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="h-80 md:h-[500px] rounded-2xl overflow-hidden shadow-lg" data-aos="fade-up" data-aos-delay="400">
                <img
                  src="/images/DIK_4128.jpg"
                  alt="Community"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

            {/* Text Content */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center pt-8" data-aos="fade-up">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Our Values</h2>
              </div>
              <div className="space-y-8">
                <p className="text-white text-lg leading-relaxed">
                  We are committed to quality, sustainability, and community. From sourcing the finest beans
                  to working directly with farmers for fair practices, we create spaces where people connect,
                  share, and discover the joy of great coffee. Every cup reflects our dedication to excellence
                  and environmental responsibility.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default OurStory;
